export const OccupiedBedIcon = () => (
  <svg width='16' height='16' viewBox='0 0 25 25' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <g clipPath='url(#clip0_occupied_bed)'>
      <path
        d='M3.125 7.29199V18.7503'
        stroke='#00A6FF'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M3.125 14.583H14.5833'
        stroke='#00A6FF'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M18.75 14.583H21.875'
        stroke='#00A6FF'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M21.875 18.7497V10.4163C21.875 9.86381 21.6555 9.3339 21.2648 8.9432C20.8741 8.55315 20.3442 8.33301 19.7917 8.33301H12.5'
        stroke='#00A6FF'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M11.4583 11.458V14.583'
        stroke='#00A6FF'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M7.29167 11.4583C7.86696 11.4583 8.33333 10.992 8.33333 10.4167C8.33333 9.84137 7.86696 9.375 7.29167 9.375C6.71637 9.375 6.25 9.84137 6.25 10.4167C6.25 10.992 6.71637 11.4583 7.29167 11.4583Z'
        stroke='#00A6FF'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M3.125 3.125L21.875 21.875'
        stroke='#00A6FF'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </g>
    <defs>
      <clipPath id='clip0_occupied_bed'>
        <rect width='25' height='25' fill='white' />
      </clipPath>
    </defs>
  </svg>
)
